import styles from './FAQPage.module.css';

const faqs = [
  {
    question: 'What is the Ego Protocol?',
    answer:
      'The Ego Protocol is a new platform for digital identity. It allows you to create a secure and AI-powered version of yourself—your Digital Self—which acts as a private, foundational core for all your public-facing AI personas and creative content.',
  },
  {
    question: 'What is my Digital Self?',
    answer:
      "Your Digital Self is your private, core identity hub, which you build in the Soulforge. It's where you define your personality, values, memories, and unique style. This data is kept private and acts as the secure 'source of truth' that powers all your AI representatives.",
  },
  {
    question: 'What are Public Profiles & Creative Personas?',
    answer:
      'These are the shareable, interactive AI personas you create and show to the world. You can create different personas for different contexts, like a professional profile for your website or a creative character for social media. Each one is powered by the data in your private Digital Self.',
  },
  {
    question: 'Why should I complete the verifications?',
    answer:
      "Verifications increase the trust and authenticity of your Digital Self. Higher verification levels (like completing the personality tests) make your AI's responses more accurate and unlock powerful features, including 'Verified' badges.",
  },
  {
    question: 'How do Ego Credits (⚡️) work?',
    answer:
      'Ego Credits are your personal monthly budget for chatting with your personas. A standard text message costs 1 credit. A message that includes an image for analysis costs 2 credits.',
  },
  {
    question: 'What are Image Credits (🎨)?',
    answer:
      'Image Credits are a special, premium currency used exclusively in the Creative Studio to generate new, original HD images. Each image generation costs 1 Image Credit and is available on paid plans.',
  },
  {
    question: 'What is the Creative Studio?',
    answer:
      "The Creative Studio is a powerful tool for generating high-quality content. You can use it to craft long-form text (like posts or articles) or generate stunning, persona-aligned images, all guided by your persona's unique voice and style.",
  },
  {
    question: 'Is my Digital Self private?',
    answer:
      'Yes. All the detailed data in your Digital Self, including your full personality profile and narrative data, is kept private to your account. Only the data you explicitly put in a Public Profile or use in a generated piece of content is shared.',
  },
];

function FAQPage() {
  return (
    <div className={styles.faqContainer}>
      <div className="page-header">
        <h2>Frequently Asked Questions</h2>
      </div>
      <p className="pageDescription">
        Have questions about the Ego Protocol? We've got answers. If you can't
        find what you're looking for, please include your question in your beta
        feedback.
      </p>

      <div className={styles.faqList}>
        {faqs.map((faq, index) => (
          <div key={index} className={styles.faqItem}>
            <h3>{faq.question}</h3>
            <p>{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQPage;
